module.exports = __webpack_public_path__ + "static/media/logo_usil.3ff2cb53.png";